import { render, staticRenderFns } from "./raccoupon.vue?vue&type=template&id=28e06424&scoped=true&"
import script from "./raccoupon.vue?vue&type=script&lang=js&"
export * from "./raccoupon.vue?vue&type=script&lang=js&"
import style0 from "./raccoupon.vue?vue&type=style&index=0&id=28e06424&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e06424",
  null
  
)

export default component.exports